import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-overlay',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div 
      class="overlay" 
      [class.active]="isVisible"
      (click)="onOverlayClick()"
      [attr.aria-hidden]="!isVisible">
    </div>
  `,
  styleUrl: './overlay.component.css'
})
export class OverlayComponent {
  @Input() isVisible: boolean = false;
  @Output() overlayClick = new EventEmitter<void>();

  onOverlayClick() {
    this.overlayClick.emit();
  }
}
